import { IModalTemplateType } from "../types";

export const OptionStyleMap: Record<
  IModalTemplateType,
  {
    variant: "outline" | "solid" | "link";
    action:
    | "default"
    | "primary"
    | "secondary"
    | "positive"
    | "negative"
    | undefined;
  }
> = {
  [IModalTemplateType.success]: {
    variant: "solid",
    action: "primary"
  },
  [IModalTemplateType.info]: {
    variant: "solid",
    action: "secondary"
  },
  [IModalTemplateType.warning]: {
    variant: "outline",
    action: "negative"
  },
  [IModalTemplateType.outline]: {
    variant: "outline",
    action: "secondary"
  },
  [IModalTemplateType.danger]: {
    variant: "solid",
    action: "negative"
  }
};
